

export const emailValidator = (email: string) => {
  const re = /\S+@\S+\.\S+/;

  if (!email || email.length <= 0) return 'Email cannot be empty.';
  if (!re.test(email)) return 'Ooops! We need a valid email address.';

  return '';
};

export const passwordValidator = (password: string) => {
  if (!password || password.length <= 0) return 'Password cannot be empty.';

  return '';
};

export const phoneValidator = (phone: string) => {
  if (phone.startsWith('(+91)')) {
    if (phone.length !== 15) {
      return 'Indian Phone number is not valid.';
    }
    return '';
  }
  else if (!phone || phone.length < 9 || phone.length > 14) {
    return 'Phone number is not valid.';
  }
  return '';
};

export const getPhoneCountryCode = (phone: string) => {

  return '(+91)';

}

export const getPhoneWithoutCountryCode = (phone: string) => {
  return phone.replace('(+91)', '');
}

export const otpValidator = (otp: string) => {
  if (!otp || otp.length != 6) return 'OTP is not valid.';

  return '';
};

export const nameValidator = (name: string) => {
  if (!name || name.length <= 0) return 'Name cannot be empty.';

  return '';
};

export const toStringRupee = (value: string): string => {
  return "₹" + new Intl.NumberFormat('en-IN', { maximumSignificantDigits: 3 }).format(parseFloat(value));
}

export const toRupee = (value: number): string => {
  return "₹" + new Intl.NumberFormat('en-IN', { maximumSignificantDigits: 3 }).format(value);
}


export const getDate = (date: string): string => {
  if (date === null || date === '') {
    date = new Date().toISOString();
  }
  const newdate = new Date(date);
  const year = newdate.getFullYear();
  const month = String(newdate.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const day = String(newdate.getDate()).padStart(2, '0');
  const formattedDate = `${year}-${month}-${day}`;
  return formattedDate;
}

export const getTime = (date: string): string => {
  if (date === null || date === '') {
    date = new Date().toISOString();
  }
  const newdate = new Date(date);
  const formattedDate = newdate.toTimeString().slice(0, 5);
  return formattedDate;
}


export const getUserColor = (count: number): string => {
  if(count === 1 )
    {return 'green'}
  if(count <= 3)
    {return 'orange'}
  return 'purple';
}

export const convertUTCToIST = (utcDate: string) => {
  const date = new Date(utcDate);

  const options: Intl.DateTimeFormatOptions = {
    timeZone: "Asia/Kolkata",
    weekday: "short",
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false
  };

  const convertedDate = new Intl.DateTimeFormat("en-IN", options).format(date);

  const formatedDate = convertedDate.replace(",", "").split(" ");
  const ISTDate = `${formatedDate[0]} ${formatedDate[1]}, ${formatedDate[2]} ${formatedDate[3]} IST`;

  return ISTDate;
};

export const formatDate = (date: string) => {
  const options: Intl.DateTimeFormatOptions = {
    weekday: "short",
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  };

  // Get the user's current time zone dynamically
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;  // Automatically detects user's time zone
  // Format the date with the user's time zone
  const formatted = new Date(date).toLocaleString("en-IN", { ...options, timeZone: userTimeZone });

  return formatted;
};